/** Saves a Blob to the user's machine with the given file name. */
export function downloadBlob(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.rel = 'noopener';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
    // give the browser time to start the download before releasing the object URL
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
